export default "__VITE_ASSET__aZVhRkfw__"